module.exports = __webpack_public_path__ + "static/media/logo-aop.2241abdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-aop.png
// module id = 332
// module chunks = 0